import { LeftSideNavigationAnchorLinks } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { NavigationElement } from '@ahc-digital/component-library';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export interface N04LeftSideNavigationAnchorLinksProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: {
    navigations?: NavigationElement;
  };
}

export const Default = (props?: N04LeftSideNavigationAnchorLinksProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource || !props?.fields?.navigations)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <LeftSideNavigationAnchorLinks
      data-elastic-exclude=""
      data-component={marketingRenderingName}
      navigations={props.fields.navigations}
    />
  );
};
